import React, { useEffect, useState } from "react";
import Container from "../../components/Layout/Container";
import ContentBlock from "../../components/Layout/ContentBlock";
import FilterMenu from "../../components/Layout/FilterMenu";
import { ButtonDelete, ButtonEditRow } from "../../components/common/Buttons";
import TableFilterBox from "../../components/common/TableFilterBox";
import ContentValidation from "../../components/common/ContentValidation";
import {
  SelectInput,
  TextInput,
  ButtonSecondary,
} from "../../components/globals";
import TableUi from "../../components/Layout/TableUI";
import { Button, Form, Input, Select, Checkbox } from "antd";
import { handleKeyDown2 } from "../../helpers/FunctionsGlobal";
import { IconPixelArt } from "../../components/Layout/Icons";
import { useModal, useFetch } from "../../hooks";
import ModalSimple from "../../components/Layout/Modals/ModalSimple";
import { QueryClient, QueryClientProvider, useMutation } from "react-query";
import Axios from "axios";
import { antdMessageError, antdMessageSuccess } from "../../helpers/Utils";
import { FaLayerGroup } from "react-icons/fa";

const queryClient = new QueryClient();

function PaymentStatusGroupsPage({ match }) {
  return (
    <QueryClientProvider client={queryClient}>
      <PaymentStatusGroupsScreen match={match} />
    </QueryClientProvider>
  );
}
export default PaymentStatusGroupsPage;

function PaymentStatusGroupsScreen({ match }) {
  const { modalOpt, setModalOpt, closeModal } = useModal();
  const [groupData, setGroupData] = useState([]);
  const [selectedPaymentType, setSelectedPaymentType] = useState([]);
  const [groupNameFilter, setGroupNameFilter] = useState("");

  const {
    value: valueStatusGroups,
    loading: loadingStatusGroups,
    setReFetch: setReFetchStatusGroups,
  } = useFetch(`/api/v1/status_groups`);

  const {
    value: valuePaymentTypes,
    loading: loadingPaymentTypes,
    setReFetch: setReFetchPaymentTypes,
  } = useFetch(`/api/v1/statuses?page=1&per_page=9999`);

  const mutationDelete = useMutation({
    mutationFn: (id) =>
      Axios({
        url: `/api/v1/status_groups/${id}`,
        method: "DELETE",
      }).then((res) => res.data),
    onSuccess: () => {
      antdMessageSuccess();
      setReFetchStatusGroups();
    },
    onError: (error) => {
      antdMessageError(error?.response?.data?.message);
    },
  });

  const clearFilter = () => {
    setGroupNameFilter("");
    setSelectedPaymentType([]);
    setGroupData(valueStatusGroups?.data || []);
  };

  const onFilter = () => {
    let filteredData = valueStatusGroups?.data || [];

    if (groupNameFilter.trim()) {
      filteredData = filterByTitle(filteredData, groupNameFilter);
    }

    if (selectedPaymentType && selectedPaymentType.length > 0) {
      filteredData = filterByPaymentType(filteredData, selectedPaymentType);
    }

    setGroupData(filteredData);
  };

  function filterByTitle(data, title) {
    return data.filter((item) =>
      item?.title?.toLowerCase()?.includes(title?.toLowerCase())
    );
  }

  function filterByPaymentType(data, selectedTypes) {
    return data.filter((item) =>
      item.payments.some((payment) => selectedTypes.includes(payment.id))
    );
  }

  const getFilteredData = () => {
    let filteredData = valueStatusGroups?.data || [];

    if (groupNameFilter.trim()) {
      filteredData = filteredData.filter((item) =>
        item.title.toLowerCase().includes(groupNameFilter.toLowerCase())
      );
    }

    if (selectedPaymentType && selectedPaymentType.length > 0) {
      filteredData = filteredData.filter((item) =>
        item.statuses.some((payment) =>
          selectedPaymentType.includes(payment.id)
        )
      );
    }

    return filteredData;
  };

  useEffect(() => {
    setReFetchStatusGroups();
  }, [modalOpt]);

  useEffect(() => {
    if (valueStatusGroups?.data) {
      setGroupData(valueStatusGroups.data);
      onFilter();
    }
  }, [valueStatusGroups]);

  return (
    <QueryClientProvider client={queryClient}>
      <Container
        location={{
          locationName: "Payment status groups",
          locationUrl: match.url,
        }}
      >
        <ContentBlock>
          <FilterMenu
            length={groupData.length || 0}
            iconComponent={<FaLayerGroup size={36} color="#828282" />}
            text2="status"
          />
        </ContentBlock>

        <ContentBlock>
          <TableFilterBox
            filter={true}
            onFilter={() => onFilter()}
            clearFilter={() => clearFilter()}
            button1={
              <>
                <div
                  className="float-left ml-2"
                  style={{
                    width: 104,
                  }}
                >
                  <ButtonSecondary onClick={() => setModalOpt("new_group", 1)}>
                    New group
                  </ButtonSecondary>
                </div>
              </>
            }
          >
            <div className="px-1 d-flex">
              <div>
                <TextInput
                  text="Group name"
                  name={groupNameFilter}
                  value={groupNameFilter || ""}
                  onKeyDown={handleKeyDown2(onFilter)}
                  onChange={(val) => {
                    const value = val.target.value;
                    setGroupNameFilter(value);
                  }}
                />
              </div>
              <div className="ml-2 w-200">
                <SelectInput
                  mode={"multiple"}
                  label="Method of payment"
                  options={valuePaymentTypes?.data
                    ?.map((paymentType) => ({
                      value: paymentType.id,
                      label: `[${paymentType?.order_shop?.title}] ${paymentType?.title}`,
                    }))
                    .filter((option) => {
                      const keywords = ["payment", "ESTO", "leasing", "lizingas", "montonio", "inbank"];
                      return keywords.some((keyword) =>
                        option.label.toLowerCase().includes(keyword.toLowerCase())
                      );
                    })}
                  value={selectedPaymentType}
                  onChange={(value) => {
                    setSelectedPaymentType(value);
                    setTimeout(onFilter, 0);
                  }}
                />
              </div>
            </div>
          </TableFilterBox>
          <div>
            <ContentValidation loader={loadingStatusGroups} array={groupData}>
              <div className="table-responsive">
                <TableUi
                  ths={["Group name", "Method of payment", ""]}
                  total={valueStatusGroups?.data?.length || 0}
                >
                  {getFilteredData()?.map((data, index) => (
                    <TableUi.tr key={index}>
                      <TableUi.td>
                        <div style={{ paddingLeft: 15 }}>
                          <p className="group-title">{data?.title}</p>
                        </div>
                      </TableUi.td>
                      <TableUi.td>
                        <div
                          className="d-flex flex-row flex-wrap gap-1"
                          style={{ paddingTop: 15, marginBottom: 15 }}
                        >
                          {data?.statuses?.map((item, i) => (
                            <div
                              className="borderder-component-text-grey d-flex flex-row"
                              key={i}
                            >
                              <p className="mr-1">{`[${item?.order_shop}] `}</p>
                              <p>{item?.name}</p>
                            </div>
                          ))}
                        </div>
                      </TableUi.td>
                      <TableUi.td>
                        <div
                          className="d-flex flex-row gap-1 justify-content-end"
                          style={{ marginRight: 15 }}
                        >
                          <ButtonEditRow
                            onClick={() => setModalOpt("edit", data.id)}
                          />
                          <ButtonDelete
                            onDelete={() => mutationDelete.mutate(data.id)}
                          />
                        </div>
                      </TableUi.td>
                    </TableUi.tr>
                  ))}
                </TableUi>
              </div>
            </ContentValidation>
          </div>
        </ContentBlock>
        {modalOpt?.type && (
          <ModalNewGroup
            modalOpt={modalOpt}
            onClose={closeModal}
            selectedPaymentType={valueStatusGroups?.data}
          />
        )}
      </Container>
    </QueryClientProvider>
  );
}

const ModalNewGroup = ({ modalOpt, onClose, selectedPaymentType }) => {
  const [searchTitle, setSearchTitle] = useState("");
  const { value } = useFetch(
    `/api/v1/statuses?page=1&per_page=9999&q[title_cont_any]=${searchTitle}`
  );

  const [form] = Form.useForm();

  const mutationPost = useMutation({
    mutationFn: (newData) =>
      Axios({
        url: `/api/v1/status_groups`,
        method: "POST",
        data: newData,
      }).then((res) => res.data),
    onSuccess: () => {
      antdMessageSuccess();
      onClose();
    },
    onError: (error) => {
      antdMessageError(error?.response?.data?.message);
    },
  });

  const mutationPut = useMutation({
    mutationFn: (updatedData) =>
      Axios({
        url: `/api/v1/status_groups/${modalOpt.record_id}`,
        method: "PUT",
        data: { status_group: updatedData },
      }).then((res) => res.data),
    onSuccess: () => {
      antdMessageSuccess();
      onClose();
    },
    onError: (error) => {
      antdMessageError(error?.response?.data?.message);
    },
  });

  useEffect(() => {
    if (modalOpt.type === "edit") {
      const editingGroup = selectedPaymentType.find(
        (group) => group.id === modalOpt.record_id
      );
      if (editingGroup) {
        form.setFieldsValue({
          title: editingGroup.title,
          disable_shipment_create: editingGroup.disable_shipment_create,
          status_ids: editingGroup.statuses.map((status) => ({
            key: status.id,
            label: `[${status.order_shop}] ${status.name}`,
          })),
        });
      }
    }
  }, [modalOpt, form]);

  const filterPaymentTypes = (payments) => {
    if (!Array.isArray(selectedPaymentType)) {
      console.error('selectedPaymentType is not an array or is undefined');
      return payments;
    }

    const keywords = ["payment", "ESTO", "leasing", "lease", "lizingas", "montonio", "inbank", "LHV"];
    return payments.filter((payment) =>
      keywords.some((keyword) =>
        payment.title?.toLowerCase().includes(keyword.toLowerCase())
      )
    );
  };

  return (
    <ModalSimple
      text={modalOpt.type === "edit" ? "Edit group" : "Create new group"}
      onClose={onClose}
      hide={true}
    >
      <Form
        form={form}
        layout="vertical"
        name="basic"
        onFinish={(values) => {
          const newCarrierIds = values.status_ids?.map(
            (carrier) => carrier.key
          );

          const transformedValues = {
            title: values.title,
            status_ids: newCarrierIds,
            disable_shipment_create: values.disable_shipment_create,
          };

          if (modalOpt.type === "edit") {
            mutationPut.mutate(transformedValues);
          } else {
            mutationPost.mutate(transformedValues);
          }
        }}
        autoComplete="off"
      >
        <Form.Item
          label="Group name"
          name="title"
          rules={[
            {
              required: true,
              message: "Please input your group name!",
            },
          ]}
        >
          <Input placeholder="Type in" />
        </Form.Item>

        <Form.Item
          label="Payment method"
          name="status_ids"
          rules={[
            {
              required: true,
              message: "Please select!",
            },
          ]}
        >
          <Select
            mode="multiple"
            placeholder="Select"
            labelInValue
            showSearch
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onSearch={(value) => setSearchTitle(value)}
          >
            {filterPaymentTypes(value?.data || [])?.map(
              ({ title, id, order_shop }) => (
                <Select.Option key={id} value={id}>
                  {`[${order_shop?.title || ''}] ${title || ''}`}
                </Select.Option>
              )
            )}
          </Select>
        </Form.Item>

        <Form.Item
          label="Disable shipment create"
          name="disable_shipment_create"
          valuePropName="checked"
        >
          <Checkbox />
        </Form.Item>

        <Form.Item>
          <Button className="w-100" type="primary" htmlType="submit">
            {modalOpt.type === "edit" ? "Update" : "Create"}
          </Button>
        </Form.Item>
      </Form>
    </ModalSimple>
  );
};
